export default __webpack_public_path__ + "static/Spyglass-3638baf23ae76b2942abc1fd7c953946.png";